import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { Component } from "react";
import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";
import { ProjectRunConfigurationStatus } from "@app/projects/enumerators";

interface AccuracySelectTrueCountyFilterProps {
  onTrueCountyChange: (trueCountySelected: boolean) => void;
  exportType: string;
  runConfigurations: ProjectRunConfiguration[];
}

export default class AccuracySelectTrueCountyFilter extends Component<AccuracySelectTrueCountyFilterProps> {
  state = {
    trueCountySelectOptions : [
      { label: "True Provider County ", value: true }
    ]
  }

  componentDidMount() {
    this.updateTrueCountySelectOptions();
  }

  componentDidUpdate(prevProps: AccuracySelectTrueCountyFilterProps) {
    if (prevProps.runConfigurations !== this.props.runConfigurations) {
      this.updateTrueCountySelectOptions();
    }
  }

  updateTrueCountySelectOptions(): void {
    //run configurations are sorted by latest ID on retrieval from the repository
    const config = this.props.runConfigurations[0];
    const isAccuracyProject = config && config.accuracyTemplateId && (config.status === ProjectRunConfigurationStatus.Succeeded);
    const isAdequacyProject = config && config.adequacyTemplateId && (config.status === ProjectRunConfigurationStatus.Succeeded ||
      config.status === ProjectRunConfigurationStatus.FailedProviderChanges);

    if (isAccuracyProject && isAdequacyProject || isAdequacyProject) {
      this.setState({
        trueCountySelectOptions : [
          ...this.state.trueCountySelectOptions ,
          { label: "Servicing Provider County", value: false }
        ]
      });
    }
  }

  public render() {
    return (
      <>
        <p className="lead mb0 demibold">True County Filter</p>
        <p>Please select a filter option:</p>
        <div className="form-group row">
          <div className="col-lg-12 ptb0">
            <QESSelect
              label="True County Filter"
              testId={`export-${this.props.exportType}__format-select`}
              className="form-control"
              onChange={(e) => this.props.onTrueCountyChange(e.target.value.toLowerCase() === "true")}
              disabled={this.state.trueCountySelectOptions.length === 1 }
            >
              {this.state.trueCountySelectOptions.map(({ label, value }) => (
                <option key={label} value={value.toString()}>{label}</option>
              ))}
            </QESSelect>
          </div>
        </div>
      </>
    );
  }
}
